import { Box, Stack } from '@mui/material';
import { useGetGuestJourneySlidingCardsQuery } from 'api/reports-service/guest-journey-hooks';
import {
  useGetGuestJourneySlidersGridQuery,
  useGetGuestJourneySlidersMemberTrendsQuery,
  useGetGuestJourneySlidersTrendsQuery,
} from 'api/reports-service/guest-journey-reports';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import MemberCountTrends from '../active-customers/member-count-trends.component';
import {
  locationsOnlyFilteredSearchParams,
  memberTrendsFilteredSearchParams,
  useSlidersSearchParams,
} from '../guest-journey.hooks';
import ReportFieldsLink from '../report-fields/report-fields-link.component';
import SlidersGrid from './sliders-grid.component';
import SlidersSummaryCards from './sliders-summary-cards.component';
import SlidersVioTrends from './sliders-vio-trends.component';

/**
 * Queries only send the params on this tab's filter bar (Locations); the
 * Member Count Trends chart additionally sends its chart-scoped date range.
 */
const filteredSearchParams = locationsOnlyFilteredSearchParams;

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useSlidersSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Sliders />
    </SearchParamsProvider>
  );
};

const Sliders = () => {
  const summary = useSearchQuery(useGetGuestJourneySlidingCardsQuery, {
    filteredSearchParams,
  });
  const vioTrends = useSearchQuery(useGetGuestJourneySlidersTrendsQuery, {
    filteredSearchParams,
  });
  const grid = useSearchQuery(useGetGuestJourneySlidersGridQuery, {
    filteredSearchParams,
  });
  const memberTrends = useSearchQuery(
    useGetGuestJourneySlidersMemberTrendsQuery,
    {
      filteredSearchParams: memberTrendsFilteredSearchParams,
    },
  );

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            summary,
            vioTrends,
            grid,
            memberTrends,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />

          <ReportFieldsLink tab="sliders" />

          <SlidersSummaryCards
            data={summary.data}
            loading={summary.queryState.isFetching}
          />

          <SlidersVioTrends
            trends={vioTrends.data?.trends}
            loading={vioTrends.queryState.isFetching}
          />

          <Box display="grid" gap={2} gridTemplateColumns={{ lg: '1fr 1fr' }}>
            <SlidersGrid
              data={grid.data}
              loading={grid.queryState.isFetching}
            />

            <MemberCountTrends
              data={memberTrends.data}
              loading={memberTrends.queryState.isFetching}
              getTitle={t =>
                t('page.guestJourney.sliders.memberCountTrendsChart.title')
              }
              data-testid="Sliders.MemberCountTrends"
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default SearchParamsWrapper;
